import { theme } from "styles/mui-config";
import styled from "styled-components";
import CardMedia from "@mui/material/CardMedia";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import ImgContainer from "components/shared/Image";

export const StyledCardMedia = styled(CardMedia)`
  height: 200px;
`;
export const StyledCardActions = styled(CardActions)`
  justify-content: end;
  padding: 20px !important;
  padding-top: 0 !important;
  & div > button {
    border-radius: 20px;
    background: ${theme.palette.primary.main};
    color: white;
    :hover {
      background: ${theme.palette.primary.dark};
      color: white;
    }
  }
`;
export const StyledImgContainer = styled(ImgContainer)`
  overflow: hidden;
  width: 93%;
  margin: auto;
  border-radius: 5px;
  & img {
    border-radius: 5px;
    height: 100% !important;
    width: auto !important;
  }
`;
export const StyledTypographyContent = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  -webkit-box-orient: vertical;
  color: rgba(0, 0, 0, 0.6);
  padding-top: 0;
`;
export const StyledCardContent = styled(CardContent)`
  color: ${theme.palette.primary.dark};
  padding: 10px !important;
  // margin-top: 20px;
  position: relative;
  & p {
    text-align: center;
    padding-top: 4px;
    font-size: 26px;
    font-family: "Avini";
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    @media (max-width: 600px) {
      font-size: 20px;
    }
  }
  &::before {
    content: "";
    position: absolute;
    right: 50%;
    left: 50%;
    top: 0px;
    width: 100px;
    border: 3px solid ${theme.palette.primary.dark};
    border-radius: 1px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    pointer-events: none;
    transform: translate(50%);
  }
`;
export const StyledCardHeader = styled.div`
  border: 2px solid #e9e9e9;
  color: #808080;
  padding: 4px !important;
  float: left;
  margin-left: 15px;
  margin-bottom: 15px;
  border-radius: 5px;
  font-size: 10px;
  display: flex;
  align-items: center;
  & span {
    margin-right: 5px;
  }
`;
export const StyledAvatar = styled(Avatar)`
  background: ${theme.palette.primary.main} !important;
`;
export const StyledTypography = styled(Typography)`
  font-size: 14px !important;
`;
